import React, { useEffect, useState } from "react";
import style from "./Navbar.module.css";
import { Link, NavLink, useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { protectedPages } from "../../../pages";
import Icons from "../../../../Assets/icons/Icons";
import UseResize from "../../../../components/Hooks/UseResize";
import { contactNumber } from "../../../../Constants/constant";
import { apiRequest } from "../../../../Api/Login";
import { useAuthStore } from "../../../../store/store";
import { Logo } from "../../../../Assets/svgs";

const AdminNavbar = () => {
  const { header, desktop } = UseResize();
  const [opentray, setopentray] = useState(false);
  const { isAuthenticated, admin } = useAuthStore()
  const navigate = useNavigate()
  const superAdmin = admin?.role === "superAdmin"
   const menu = protectedPages.filter(
  (page) =>
    !page.route.includes(":") &&
    (superAdmin || page.route !== "/admin/admins")
);

  useEffect(() => {
    AOS.init({
      once: false,
      easing: "linear",
    });
  }, []);

  useEffect(() => {
    if (opentray) {
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: false,
      });
      AOS.refresh();
    } else {
      const animatedElements = document.querySelectorAll("navAni");
      animatedElements.forEach((el) => {
        el.setAttribute("data-aos", "fade-out");
      });
      AOS.refresh();
    }
  }, [opentray]);

  useEffect(() => {
    if (desktop) {
      setopentray(true);
    } else {
      setopentray(false);
    }
  }, [desktop]);

  const logout = async () => {
    const req = await apiRequest("get", "/auth/logout")
    if(req){
      navigate("/admin/login")
      useAuthStore.getState().setAuthenticated(false);
      useAuthStore.getState().setAdmin({});
    }
  }

  return (
    <nav className={`${style.nav} ${header ? style.active_header : ""}`}>
      <NavLink to="/admin/dashboard" onClick={() => {
        if (!desktop) setopentray(false);
      }}>
        <div className={style.logo}>
          <img src={Logo} alt="lexrae logo" />
        </div>
      </NavLink>
      <div className={`${style.menu} ${opentray ? style.active : ""}`}>
        <div className={`${style.menuHeader} desktop`}>
          <Link
            to="/admin/dashboard"
            className={`${style.headerlogo} ${opentray ? style.active : ""} navAni`}
            data-aos={"fade-in"}
          >
            <img
              src={Logo}
              alt="Go back Home"
              onClick={() => setopentray(false)}
            />
          </Link>
          <div className={style.times} onClick={() => setopentray(false)}>
            {Icons.times}
          </div>
        </div>
        <ul>
          {menu.map((e, index) => (
            <li
              key={e.name}
              className={`${opentray ? style.block  : ""} navAni` }
              data-aos={opentray ? "fade-right" : "fade-out"}
              data-aos-delay={`${index * 200}`}
            >

              <NavLink
                className={({ isActive }) => (isActive ? "active-link" : "")}
                to={e.route}
                onClick={() => {
                  if (!desktop) setopentray(false);
                }}
              >
                {e.name}
              </NavLink>
            </li>
          ))}
          {isAuthenticated ?
            <li 
              className= {`${style.logout} navAni`}
              data-aos={opentray ? "fade-right" : "fade-out"}
              data-aos-delay={`${3 * 200}`} 
              onClick={logout}
            >
                Logout
              </li>
              : null
            }
        </ul>
        <div className={style.menuContact}>
          {Icons.phone}
          <p>{contactNumber}</p>
        </div>
        <div className={`${style.footer} mobile`}>
          <div className={style.privacy}>
            <a
              href="https://drive.google.com/file/d/1HhfWWS2H4sed0JO739JE20k5_bH84e9W/view?usp=drive_link" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
            <a
              href="https://drive.google.com/file/d/10yMYZLioeiqf5wy9IJmQm5h_QziCyisY/view?usp=drive_link" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              Terms & Conditions
            </a>
          </div>
          <p>© 2025 Lexrae support - All rights reserved</p>
        </div>
      </div>
      <div className={`${style.openTray} mobile`}>
        <div onClick={() => setopentray(true)}>{Icons.menu}</div>
      </div>
    </nav>
  );
};

export default AdminNavbar;
